// Tutorials Block Component
import React, { useState, useEffect } from 'react';
import { BookOpen } from 'lucide-react';
import api from '../../services/api';

const TutorialsBlock = ({ content, padding, backgroundColor, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [projectId, setProjectId] = useState(content?.projectId || '');
  const [showSteps, setShowSteps] = useState(content?.showSteps !== false);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const response = await api.get('/projects');
      setProjects(response.projects || []);
    } catch (error) {
      console.error('Error fetching projects:', error);
    }
  };

  const handleSave = () => {
    onUpdate({ content: { projectId, showSteps } });
    setIsEditing(false);
  };

  const getPaddingClass = () => {
    switch (padding) {
      case 'none': return 'p-0';
      case 'small': return 'p-4';
      case 'large': return 'p-12';
      default: return 'p-8';
    }
  };

  if (isEditing) {
    return (
      <div className={getPaddingClass()} style={{ backgroundColor }}>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-[#3C3C3C] dark:text-gray-100 mb-2">
              Select Project
            </label>
            <select
              value={projectId}
              onChange={(e) => setProjectId(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-700 text-[#3C3C3C] dark:text-gray-100"
            >
              <option value="">Select a project...</option>
              {projects.map((project) => (
                <option key={project.id} value={project.id}>
                  {project.title || project.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={showSteps}
                onChange={(e) => setShowSteps(e.target.checked)}
                className="rounded border-gray-300 dark:border-gray-600"
              />
              <span className="text-sm text-[#3C3C3C] dark:text-gray-100">
                Show tutorial steps
              </span>
            </label>
          </div>

          <div className="flex gap-2">
            <button onClick={handleSave} className="px-4 py-2 bg-[#7A99D8] text-white rounded hover:bg-[#6A89C8]">Save</button>
            <button onClick={() => setIsEditing(false)} className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded text-[#3C3C3C] dark:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-700">Cancel</button>
          </div>
        </div>
      </div>
    );
  }

  const selectedProject = projects.find(p => p.id === projectId);

  return (
    <div className={getPaddingClass()} style={{ backgroundColor }}>
      <div className="text-center">
        <BookOpen className="w-12 h-12 text-[#7A99D8] mx-auto mb-4" />
        <h3 className="text-lg font-semibold text-[#3C3C3C] dark:text-gray-100 mb-2">Tutorial</h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          {selectedProject ? (selectedProject.title || selectedProject.name) : 'No project selected'}
        </p>
      </div>
    </div>
  );
};

export default TutorialsBlock;
